export default __webpack_public_path__ + "static/media/restaurant_red.456e09dd.svg";